import React from 'react'

const Intro = ({ i18n, frequencies }) => {
  const intro = i18n.t('intro')

  return (
    <>
      {
        frequencies?.length == 1 && frequencies[0] != 'one_time' &&
        <h2 className="h3 mb-3 text-center">
          {i18n.t(`subscription_labels.${frequencies[0]}.lineItem`)}
        </h2>
      }
      {
        intro && !/^<p>(<br>)?<\/p>$/i.test(intro) &&
        <div className="intro mb-4" dangerouslySetInnerHTML={{ __html: intro }} />
      }
    </>
  )
}

export default Intro
